import type { FC } from 'react';
import type { SxProps } from '@mui/system/styleFunctionSx';
import Stack from '@mui/material/Stack';
import { usePopover } from 'src/hooks/use-popover';
import { TenantPopover } from './tenant-popover';
import logo from '../../../../public/assets/rs-logo.svg';
import { IconButton, useMediaQuery } from '@mui/material';

const tenants: string[] = ['Devias', 'Acme Corp'];

const LeftArrowIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99707 14.9163L9.16618 10.7472L4.99707 6.57812M10.8338 14.9163L15.0029 10.7472L10.8338 6.57812"
        stroke="#6C737F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const RightArrowIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.003 14.9163L9.83388 10.7472L14.003 6.57812M9.16717 14.9163L4.99806 10.7472L9.16717 6.57812"
        stroke="#6C737F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

interface TenantSwitchProps {
  sx?: SxProps;
  setIsSideNav: any;
  isSideNav: boolean;
}

export const LogoText = () => {
  return (
    <svg
      width="197"
      height="37"
      viewBox="0 0 197 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.55035 11.4894H14.2713C15.023 11.4894 15.7329 11.5668 16.401 11.7217C17.0831 11.8624 17.6747 12.1087 18.1758 12.4606C18.6908 12.7984 19.0945 13.2629 19.3868 13.8541C19.693 14.4312 19.8462 15.1561 19.8462 16.0288C19.8462 17.0845 19.5747 17.9853 19.0319 18.7313C18.489 19.4633 17.6956 19.9278 16.6516 20.1248L20.4099 26.4377H16.5054L13.4153 20.4626H11.8076V26.4377H8.55035V11.4894ZM11.8076 17.6757H13.7285C14.0208 17.6757 14.327 17.6686 14.6472 17.6545C14.9812 17.6264 15.2805 17.5631 15.545 17.4645C15.8095 17.3519 16.0252 17.183 16.1922 16.9578C16.3732 16.7326 16.4637 16.4159 16.4637 16.0077C16.4637 15.6277 16.3871 15.325 16.234 15.0998C16.0809 14.8746 15.886 14.7057 15.6494 14.5931C15.4127 14.4664 15.1413 14.382 14.8351 14.3397C14.5288 14.2975 14.2296 14.2764 13.9373 14.2764H11.8076V17.6757Z"
        fill="#A259FF"
      />
      <path
        d="M22.2147 11.4894H32.2577V14.5298H25.4719V17.3167H31.8819V20.3571H25.4719V23.3974H32.6335V26.4377H22.2147V11.4894Z"
        fill="#A259FF"
      />
      <path
        d="M42.5488 15.142C42.2844 14.8042 41.9225 14.5579 41.4631 14.4031C41.0177 14.2342 40.5931 14.1497 40.1895 14.1497C39.9528 14.1497 39.7092 14.1779 39.4587 14.2342C39.2081 14.2905 38.9715 14.382 38.7488 14.5086C38.5261 14.6212 38.3451 14.7761 38.2059 14.9731C38.0667 15.1702 37.9971 15.4095 37.9971 15.691C37.9971 16.1414 38.1641 16.4863 38.4982 16.7256C38.8323 16.9648 39.2499 17.1689 39.751 17.3378C40.266 17.5067 40.8158 17.6757 41.4005 17.8446C41.9851 18.0135 42.528 18.2528 43.0291 18.5624C43.5441 18.8721 43.9686 19.2873 44.3027 19.8081C44.6368 20.3289 44.8038 21.0257 44.8038 21.8983C44.8038 22.7288 44.6507 23.4537 44.3445 24.073C44.0382 24.6924 43.6206 25.2061 43.0917 25.6143C42.5767 26.0225 41.9712 26.3251 41.2752 26.5222C40.5931 26.7192 39.8693 26.8178 39.1037 26.8178C38.1433 26.8178 37.2524 26.67 36.4311 26.3744C35.6099 26.0788 34.8443 25.6002 34.1344 24.9387L36.452 22.3628C36.7861 22.8133 37.2037 23.1651 37.7048 23.4185C38.2198 23.6578 38.7488 23.7774 39.2916 23.7774C39.5561 23.7774 39.8206 23.7493 40.0851 23.693C40.3634 23.6226 40.607 23.5241 40.8158 23.3974C41.0385 23.2707 41.2125 23.1088 41.3378 22.9118C41.477 22.7147 41.5466 22.4825 41.5466 22.215C41.5466 21.7646 41.3726 21.4127 41.0246 21.1594C40.6906 20.8919 40.266 20.6667 39.751 20.4837C39.236 20.3008 38.6792 20.1178 38.0806 19.9348C37.4821 19.7518 36.9253 19.5055 36.4103 19.1958C35.8952 18.8862 35.4637 18.478 35.1157 17.9712C34.7817 17.4645 34.6146 16.7959 34.6146 15.9655C34.6146 15.1632 34.7677 14.4594 35.074 13.8541C35.3941 13.2489 35.8117 12.7421 36.3267 12.334C36.8557 11.9258 37.4612 11.6231 38.1433 11.4261C38.8253 11.2149 39.5283 11.1094 40.2521 11.1094C41.0873 11.1094 41.8946 11.229 42.6741 11.4683C43.4536 11.7076 44.1566 12.1087 44.7829 12.6718L42.5488 15.142Z"
        fill="#A259FF"
      />
      <path
        d="M50.0909 14.4031H45.8732V11.4894H57.5657V14.4031H53.3481V26.4377H50.0909V14.4031Z"
        fill="#A259FF"
      />
      <path
        d="M58.4264 18.9636C58.4264 17.7671 58.6213 16.6833 59.011 15.7121C59.4147 14.7409 59.9715 13.9175 60.6814 13.2418C61.3913 12.5521 62.2334 12.0243 63.2078 11.6583C64.1822 11.2924 65.247 11.1094 66.4023 11.1094C67.5577 11.1094 68.6225 11.2924 69.5969 11.6583C70.5713 12.0243 71.4134 12.5521 72.1233 13.2418C72.8332 13.9175 73.383 14.7409 73.7728 15.7121C74.1765 16.6833 74.3783 17.7671 74.3783 18.9636C74.3783 20.16 74.1765 21.2438 73.7728 22.215C73.383 23.1863 72.8332 24.0167 72.1233 24.7064C71.4134 25.3821 70.5713 25.9029 69.5969 26.2688C68.6225 26.6348 67.5577 26.8178 66.4023 26.8178C65.247 26.8178 64.1822 26.6348 63.2078 26.2688C62.2334 25.9029 61.3913 25.3821 60.6814 24.7064C59.9715 24.0167 59.4147 23.1863 59.011 22.215C58.6213 21.2438 58.4264 20.16 58.4264 18.9636ZM61.8088 18.9636C61.8088 19.6674 61.9132 20.3148 62.122 20.906C62.3448 21.4831 62.6579 21.9898 63.0616 22.4262C63.4653 22.8484 63.9455 23.1792 64.5023 23.4185C65.073 23.6578 65.7064 23.7774 66.4023 23.7774C67.0983 23.7774 67.7247 23.6578 68.2815 23.4185C68.8522 23.1792 69.3394 22.8484 69.743 22.4262C70.1467 21.9898 70.453 21.4831 70.6617 20.906C70.8845 20.3148 70.9958 19.6674 70.9958 18.9636C70.9958 18.2739 70.8845 17.6334 70.6617 17.0423C70.453 16.4511 70.1467 15.9444 69.743 15.5221C69.3394 15.0857 68.8522 14.7479 68.2815 14.5086C67.7247 14.2694 67.0983 14.1497 66.4023 14.1497C65.7064 14.1497 65.073 14.2694 64.5023 14.5086C63.9455 14.7479 63.4653 15.0857 63.0616 15.5221C62.6579 15.9444 62.3448 16.4511 62.122 17.0423C61.9132 17.6334 61.8088 18.2739 61.8088 18.9636Z"
        fill="#A259FF"
      />
      <path
        d="M76.5922 11.4894H82.3131C83.0648 11.4894 83.7747 11.5668 84.4428 11.7217C85.1249 11.8624 85.7165 12.1087 86.2176 12.4606C86.7326 12.7984 87.1363 13.2629 87.4286 13.8541C87.7348 14.4312 87.888 15.1561 87.888 16.0288C87.888 17.0845 87.6165 17.9853 87.0737 18.7313C86.5308 19.4633 85.7374 19.9278 84.6934 20.1248L88.4517 26.4377H84.5472L81.4571 20.4626H79.8494V26.4377H76.5922V11.4894ZM79.8494 17.6757H81.7703C82.0626 17.6757 82.3688 17.6686 82.689 17.6545C83.023 17.6264 83.3223 17.5631 83.5868 17.4645C83.8513 17.3519 84.067 17.183 84.2341 16.9578C84.415 16.7326 84.5055 16.4159 84.5055 16.0077C84.5055 15.6277 84.4289 15.325 84.2758 15.0998C84.1227 14.8746 83.9278 14.7057 83.6912 14.5931C83.4546 14.4664 83.1831 14.382 82.8769 14.3397C82.5707 14.2975 82.2714 14.2764 81.9791 14.2764H79.8494V17.6757Z"
        fill="#A259FF"
      />
      <path
        d="M90.2565 11.4894H100.3V14.5298H93.5137V17.3167H99.9237V20.3571H93.5137V23.3974H100.675V26.4377H90.2565V11.4894Z"
        fill="#A259FF"
      />
      <ellipse
        cx="10.1207"
        cy="8.49271"
        rx="1.57031"
        ry="1.57084"
        fill="#A259FF"
      />
      <path
        d="M187.787 23.3022C188.138 23.8287 188.583 24.2202 189.123 24.4767C189.677 24.7197 190.244 24.8412 190.824 24.8412C191.148 24.8412 191.479 24.7939 191.817 24.6994C192.154 24.5914 192.458 24.4362 192.728 24.2337C193.011 24.0312 193.241 23.7814 193.416 23.4844C193.592 23.1874 193.68 22.8432 193.68 22.4517C193.68 21.8982 193.504 21.4797 193.153 21.1962C192.802 20.8992 192.363 20.6562 191.837 20.4672C191.324 20.2647 190.757 20.0757 190.136 19.9002C189.528 19.7112 188.961 19.4547 188.435 19.1307C187.922 18.8067 187.49 18.3747 187.139 17.8347C186.788 17.2812 186.612 16.5387 186.612 15.6072C186.612 15.1887 186.7 14.7432 186.876 14.2707C187.065 13.7982 187.355 13.3662 187.746 12.9747C188.138 12.5832 188.637 12.2592 189.245 12.0027C189.866 11.7327 190.608 11.5977 191.472 11.5977C192.255 11.5977 193.005 11.7057 193.72 11.9217C194.436 12.1377 195.063 12.5764 195.603 13.2379L194.024 14.6757C193.781 14.2977 193.437 13.9939 192.991 13.7644C192.546 13.5349 192.039 13.4202 191.472 13.4202C190.932 13.4202 190.48 13.4944 190.116 13.6429C189.765 13.7779 189.481 13.9602 189.265 14.1897C189.049 14.4057 188.894 14.6419 188.799 14.8984C188.718 15.1549 188.678 15.3912 188.678 15.6072C188.678 16.2147 188.853 16.6804 189.204 17.0044C189.555 17.3284 189.987 17.5917 190.5 17.7942C191.027 17.9967 191.594 18.1789 192.201 18.3409C192.822 18.5029 193.389 18.7324 193.902 19.0294C194.429 19.3129 194.868 19.7044 195.219 20.2039C195.57 20.6899 195.745 21.3649 195.745 22.2289C195.745 22.9174 195.61 23.5384 195.34 24.0919C195.084 24.6454 194.733 25.1112 194.287 25.4892C193.842 25.8672 193.315 26.1574 192.708 26.3599C192.1 26.5624 191.452 26.6637 190.764 26.6637C189.846 26.6637 188.975 26.5017 188.151 26.1777C187.328 25.8537 186.673 25.3542 186.187 24.6792L187.787 23.3022Z"
        fill="black"
      />
      <path
        d="M178.528 13.7834H173.911V11.9609H185.089V13.7834H180.472V26.2979H178.528V13.7834Z"
        fill="black"
      />
      <path
        d="M160.319 11.9609H162.263V17.9144H169.695V11.9609H171.639V26.2979H169.695V19.7369H162.263V26.2979H160.319V11.9609Z"
        fill="black"
      />
      <path
        d="M156.566 18.2802V25.3474C156.215 25.5634 155.817 25.7524 155.372 25.9144C154.926 26.0764 154.46 26.2114 153.974 26.3194C153.502 26.4409 153.016 26.5287 152.516 26.5827C152.03 26.6367 151.571 26.6637 151.139 26.6637C149.924 26.6637 148.838 26.4612 147.879 26.0562C146.934 25.6512 146.131 25.1044 145.469 24.4159C144.821 23.7274 144.322 22.9309 143.971 22.0264C143.633 21.1084 143.465 20.1432 143.465 19.1307C143.465 18.0642 143.647 17.0719 144.011 16.1539C144.389 15.2359 144.902 14.4394 145.55 13.7644C146.212 13.0894 147.002 12.5629 147.92 12.1849C148.838 11.7934 149.843 11.5977 150.937 11.5977C152.26 11.5977 153.34 11.7664 154.177 12.1039C155.014 12.4279 155.716 12.8802 156.283 13.4607L154.906 14.9389C154.312 14.3719 153.684 13.9804 153.023 13.7644C152.361 13.5349 151.666 13.4202 150.937 13.4202C150.113 13.4202 149.371 13.5754 148.709 13.8859C148.048 14.1829 147.481 14.5879 147.008 15.1009C146.536 15.6139 146.171 16.2214 145.915 16.9234C145.658 17.6119 145.53 18.3477 145.53 19.1307C145.53 19.9407 145.672 20.6967 145.955 21.3987C146.239 22.0872 146.63 22.6879 147.13 23.2009C147.629 23.7139 148.217 24.1189 148.892 24.4159C149.567 24.6994 150.302 24.8412 151.099 24.8412C151.787 24.8412 152.435 24.7804 153.043 24.6589C153.664 24.5239 154.19 24.3349 154.622 24.0919V20.1027H151.443V18.2802H156.566Z"
        fill="black"
      />
      <path
        d="M138.517 11.9609H140.461V26.2979H138.517V11.9609Z"
        fill="black"
      />
      <path
        d="M127.488 23.3022C127.839 23.8287 128.284 24.2202 128.824 24.4767C129.378 24.7197 129.945 24.8412 130.525 24.8412C130.849 24.8412 131.18 24.7939 131.517 24.6994C131.855 24.5914 132.159 24.4362 132.429 24.2337C132.712 24.0312 132.942 23.7814 133.117 23.4844C133.293 23.1874 133.38 22.8432 133.38 22.4517C133.38 21.8982 133.205 21.4797 132.854 21.1962C132.503 20.8992 132.064 20.6562 131.538 20.4672C131.025 20.2647 130.458 20.0757 129.837 19.9002C129.229 19.7112 128.662 19.4547 128.136 19.1307C127.623 18.8067 127.191 18.3747 126.84 17.8347C126.489 17.2812 126.313 16.5387 126.313 15.6072C126.313 15.1887 126.401 14.7432 126.576 14.2707C126.765 13.7982 127.056 13.3662 127.447 12.9747C127.839 12.5832 128.338 12.2592 128.946 12.0027C129.567 11.7327 130.309 11.5977 131.173 11.5977C131.956 11.5977 132.705 11.7057 133.421 11.9217C134.136 12.1377 134.764 12.5764 135.304 13.2379L133.725 14.6757C133.482 14.2977 133.137 13.9939 132.692 13.7644C132.246 13.5349 131.74 13.4202 131.173 13.4202C130.633 13.4202 130.181 13.4944 129.816 13.6429C129.465 13.7779 129.182 13.9602 128.966 14.1897C128.75 14.4057 128.595 14.6419 128.5 14.8984C128.419 15.1549 128.379 15.3912 128.379 15.6072C128.379 16.2147 128.554 16.6804 128.905 17.0044C129.256 17.3284 129.688 17.5917 130.201 17.7942C130.728 17.9967 131.295 18.1789 131.902 18.3409C132.523 18.5029 133.09 18.7324 133.603 19.0294C134.13 19.3129 134.568 19.7044 134.919 20.2039C135.27 20.6899 135.446 21.3649 135.446 22.2289C135.446 22.9174 135.311 23.5384 135.041 24.0919C134.784 24.6454 134.433 25.1112 133.988 25.4892C133.542 25.8672 133.016 26.1574 132.408 26.3599C131.801 26.5624 131.153 26.6637 130.464 26.6637C129.546 26.6637 128.676 26.5017 127.852 26.1777C127.029 25.8537 126.374 25.3542 125.888 24.6792L127.488 23.3022Z"
        fill="black"
      />
      <path
        d="M110.743 11.9609H113.295L121.192 23.7464H121.233V11.9609H123.177V26.2979H120.706L112.728 14.5124H112.687V26.2979H110.743V11.9609Z"
        fill="black"
      />
      <path
        d="M104.904 11.9609H106.848V26.2979H104.904V11.9609Z"
        fill="black"
      />
    </svg>
  );
};
export const Logo = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.125"
        width="33.75"
        height="33.75"
        rx="5.625"
        fill="#A259FF"
      />
      <path
        d="M14.4825 23.2031L11.6902 18.2712H10.4935V23.2031H7.95508V10.5469H12.7056C13.6847 10.5469 14.5188 10.7222 15.2078 11.0727C15.8968 11.4112 16.4105 11.8766 16.749 12.4689C17.0996 13.0491 17.2748 13.7019 17.2748 14.4272C17.2748 15.2612 17.0331 16.0167 16.5496 16.6937C16.066 17.3585 15.3468 17.8179 14.3919 18.0717L17.4199 23.2031H14.4825ZM10.4935 16.3673H12.615C13.304 16.3673 13.8177 16.2041 14.1562 15.8777C14.4946 15.5393 14.6638 15.0739 14.6638 14.4816C14.6638 13.9013 14.4946 13.4541 14.1562 13.1398C13.8177 12.8134 13.304 12.6502 12.615 12.6502H10.4935V16.3673Z"
        fill="white"
      />
      <circle
        cx="26.1406"
        cy="21.7969"
        r="1.40625"
        fill="white"
      />
      <path
        d="M22.6089 10.7617V23.2043H20.0381V10.7617H22.6089Z"
        fill="white"
      />
      <circle
        cx="9.36133"
        cy="7.68359"
        r="1.40625"
        fill="white"
      />
    </svg>
  );
};

export const TenantSwitch: FC<TenantSwitchProps> = (props) => {
  const popover = usePopover<HTMLButtonElement>();
  const lgdown = useMediaQuery((theme: any) => theme.breakpoints.down('1600'));

  return (
    <>
      <Stack
        alignItems="center"
        direction={props.isSideNav ? 'row' : 'column'}
        spacing={2}
        {...props}
      >
        {/* <img src={logo} /> */}

        {props.isSideNav ? <LogoText /> : <Logo />}
        {lgdown && (
          <IconButton onClick={(event) => props.setIsSideNav((prev: boolean) => !prev)}>
            {props.isSideNav ? <RightArrowIcon /> : <LeftArrowIcon />}
          </IconButton>
        )}
      </Stack>

      <TenantPopover
        anchorEl={popover.anchorRef.current}
        onChange={popover.handleClose}
        onClose={popover.handleClose}
        open={popover.open}
        tenants={tenants}
      />
    </>
  );
};
